import { Box, Link as MuiLink, Typography } from "@mui/material";
import { TasksDisplay } from "components/Tasks/TasksDisplay";
import { Link, useParams } from "react-router-dom";
import { TaskFilterChips } from "routes/Customer/Tasks/TaskFilterChips";

export const TasksSection: React.FC = () => {
  const { tenantId, facilityId } = useParams<{ tenantId: string; facilityId: string }>();

  const commandButtons = () => [] as React.ReactNode[];

  const defaultSearch = `tenantId:${tenantId} facilityId:${facilityId} taskStatus:OPEN|IN_PROGRESS|COMPLETED`;

  return (
    <>
      <Typography variant="h5" mb={1}>
        Facility Tasks
      </Typography>
      <Typography variant="body2" color="text.primary" mb={3}>
        Showing all current facility tasks. To see all tasks or add a new one, open{" "}
        <MuiLink component={Link} to={`/o/${tenantId}/tasks`} underline="none">
          Tasks
        </MuiLink>
        .
      </Typography>
      <Box sx={{ mx: -3 }}>
        <TasksDisplay
          additionalFilterColumns={[]}
          commandButtons={commandButtons}
          defaultSearch={defaultSearch}
          persistenceKey={`facility-tasks-${facilityId}`}
          topContent={
            <Box sx={{ mx: 3 }}>
              <TaskFilterChips facilityId={facilityId} />
            </Box>
          }
        />
      </Box>
    </>
  );
};
